export const formatTimeOnly = (dateString: string) => {
  if (!dateString) return '--:--';
  const d = new Date(dateString);
  return d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
};

export const formatDayOnly = (dateString: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();

  // איפוס השעות לחצות כדי להשוות תאריכים קלנדריים נקיים
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const todayOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  // חישוב הפרש הימים המדויק
  const diffInTime = todayOnly.getTime() - dateOnly.getTime();
  const diffInDays = Math.round(diffInTime / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) return 'TODAY';
  if (diffInDays === 1) return 'YESTERDAY';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }).toUpperCase();
};